import React from "react";

const Map = () => {
  return (
    <>
      <div className="google-map">
        <iframe
          className="embed-responsive-item"
          title="my location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2845.1606175026873!2d7.914398900000001!3d44.511863399999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12d2a462c00070c3%3A0xa16ce847b4b8b589!2sVia%20Asilo%2C%2023%2C%2012060%20Farigliano%20CN!5e0!3m2!1sit!2sit!4v1648310396856!5m2!1sit!2sit"
        ></iframe>
      </div>
      {/* End google-map */}
    </>
  );
};

export default Map;
